const translations = {
  "weather.current": { en: "Current", fr: "Actuel" },
  "weather.today": { en: "Today", fr: "Aujourd'hui" },
  "weather.tomorrow": { en: "Tomorrow", fr: "Demain" },
  "weather.noData": {
    en: "No weather data available.",
    fr: "Aucune donnée météorologique disponible.",
  },
  "notice.fallbackTitle": { en: "Notice", fr: "Avis" },
  "error.reloading": {
    en: "Something went wrong; reloading in {seconds} seconds...",
    fr: "Un problème est survenu; rechargement dans {seconds} secondes...",
  },
  "privacy.notice": {
    en: "This screen runs software to generate anonymous statistics about audience counts and estimated age and gender. Scan for more information.",
    fr: "Cet écran utilise un logiciel pour générer des statistiques anonymes sur le nombre de spectateurs ainsi que leur âge et sexe estimés. Scannez pour plus d\u2019informations.",
  },
  "alt.propertyLogo": { en: "Property Logo", fr: "Logo de la propriété" },
  "alt.verticalCityLogo": {
    en: "Vertical City Logo",
    fr: "Logo Vertical City",
  },
  "alt.privacyQr": {
    en: "Privacy QR Code",
    fr: "Code QR de confidentialité",
  },
  "alt.logo": { en: "Logo", fr: "Logo" },
  "alt.background": { en: "background", fr: "arrière-plan" },
  "alt.main": { en: "main", fr: "principal" },
} as const;

type TranslationKey = keyof typeof translations;
type Language = keyof (typeof translations)[TranslationKey];

export function t(key: TranslationKey, lang: Language | (string & {})): string {
  const entry = translations[key];
  return (entry as Record<string, string>)[lang] ?? entry.en;
}
